import React from 'react';
export function StickyAlertBar() {
  return <div className="sticky top-0 z-50 bg-urgency text-white py-3 px-4 text-center font-body font-semibold shadow-lg" data-id="element-118">
      <p className="text-sm md:text-base" data-id="element-119">
        +2000 descargas - Oferta por tiempo limitado ⏰
      </p>
    </div>;
}